import { Component, OnInit, Input, TemplateRef, ViewChild, Output, EventEmitter } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SweetAlertResult } from "sweetalert2";

import { SharedService } from "@services/shared.service";
import { ApiTransactionService } from "@services/api-transaction.service";

import { CustomerModel } from "@models/CustomerModel";

import { ModalFormBase } from "@shared/modal-base.component";

import { envVariables } from "@shared/mock-data";

import { IPurchaseWithPoints } from "@models/TransactionModel";
import { Constants } from "@shared/shared.constants";
import { Country } from "@shared/models/Enums";

@Component({
    selector: "app-purchase-with-points-modal",
    templateUrl: "./purchase-with-points-modal.component.html",
    styleUrls: ["./purchase-with-points-modal.component.scss"],
})
export class PurchaseWithPointsModalComponent extends ModalFormBase<IPurchaseWithPoints> implements OnInit {
    @Input() user: CustomerModel;
    @Input() model: IPurchaseWithPoints;
    @Input() pointsSelected: number;

    @Output() sendPointsSelected = new EventEmitter<number>();

    @ViewChild("purchaseModal", { static: true }) modal: TemplateRef<any>;

    exceededPointsFlag = false;

    // form
    formGroup: UntypedFormGroup;

    currencySymbol = '₡';

    constructor(
        private router: Router,
        public sharedService: SharedService,
        public modalService: NgbModal,
        private apiTransactionService: ApiTransactionService
    ) {
        super(modalService);
    }

    ngOnInit(): void {

        const session = this.apiTransactionService.getSession();
        
        if(session?.user?.country == Country.CR) this.currencySymbol = '₡';
        else if(session?.user?.country == Country.PA) this.currencySymbol = '$';

    }

    onOpen(purchaseModal: any) {
        if (!this.user) {
            // Return alert
            return this.sharedService.SwalCustom.fire({
                title: "Iniciar sesión",
                text: "Para aplicar puntos debe iniciar sesión.",
                showCancelButton: true,

                cancelButtonText: "Cancelar",
                confirmButtonText: "Iniciar sesión",

                allowOutsideClick: false,

                customClass: {
                    confirmButton: "btn btn-modal-main",
                    cancelButton: "btn btn-modal-second",
                },
                buttonsStyling: false,
            }).then((result: SweetAlertResult) => {
                if (result && result.value) {
                    this.router.navigate(["login"]);
                }
            });
        }

        setTimeout(() => window.scrollTo({ top: 0 }), 100);

        this.onNext();

        super.open(this.modal, {
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-dialog-end modal-content-full",
        });
    }

    onClose() {
        super.close();
    }

    // cuando se selecciona el giftcard y va al resumen de pago
    onNext() {
        this._formInit();
    }

    onPay() {
        if (this.model) {
            this.model.points;
            this.model.total = this.model.points;
        }
    }

    onUpdatePoints(event: any) {
        //calculate the max amount of point that the user could use in his purchase
        const pointValue = envVariables[Constants.ENV_POINTS_VALUE_KEY] ?? 1;
        let maxPoints = (this.model.subTotal * 0.8) / parseInt(pointValue, 10);

        if (event.target.value > maxPoints) {
            //if te values inserted is higer than the max of point we set the event and points selected as max of points
            event.target.value = maxPoints;
            this.pointsSelected = maxPoints;
            this.exceededPointsFlag = true;
        } else {
            //set the points selected
            this.pointsSelected = event.target.value;
            this.exceededPointsFlag = false;
        }
        //send to father component the points
        this.sendPointsSelected.emit(this.pointsSelected);
    }

    onValidatePointsInput(event: any) {

        if (event.target.value > this.user.availablePoints) {
            // validate the manual input in case of the user put a number higher than availablePoints
            event.target.value = this.user.availablePoints;
            this.sendPointsSelected.emit(this.user.availablePoints);
        } else if (event.target.value < 0) {
            // validate the manual input in case of the user put a number lower than 0
            event.target.value = 0;
            this.sendPointsSelected.emit(0);
        }
    }

    // Form

    get name() {
        return this._formGet(this.formGroup, "name");
    }
    get invalidName(): boolean {
        return this._isInvalid(this.formGroup, "name", true);
    }

    private _formInit(): void {
        // Reset for hide form errors
        this.touched = true;

        this.formGroup = new UntypedFormGroup({
            points: new UntypedFormControl("", [
                Validators.required,
                Validators.min(1),
            ]),
        });
    }

    // End Form
}
